import { gql } from "@apollo/client";

export const getRegisteredDogsTrialByTrialCalendarQuery = gql`
  query getRegisteredDogsTrialByTrialCalendar(
    $trialCalendarId: Int!
    $pageNumber: Int!
    $pageSize: Int!
    $search: String
  ) {
    getRegisteredDogsTrialByTrialCalendar(
      pageNumber: $pageNumber
      pageSize: $pageSize
      trialCalendarId: $trialCalendarId
      search: $search
    ) {
      data {
        id
        dog
        division
        elements
        authId
        trialCalendarId
        memberName
        email
        address
        phoneNumber
        emergencyContactName
        emergencyContactNumber
        breed
      }
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
    }
  }
`;
